// extracted by mini-css-extract-plugin
export default {"actionInput":"styles_actionInput__WO1oT","labeledInput":"styles_labeledInput__jQP4q"};